{
  "error-message-wrapper": {
    "text": {
      "custom": "{{ message }}",
      "email": "Neplatný e-mail",
      "format": "Nesprávný formát ({{ correctFormat }})",
      "inRange": "{{ nameOfThisControl }} musí být od {{ min }} do {{ max }}",
      "notEarlier": "{{ nameOfThisControl }} musí být pozdější než {{ nameOfAnotherControl }}",
      "min": "Vstupní hodnota nesmí být menší než {{ min }}",
      "max": "Vstupní hodnota nesmí být větší než {{ max }}",
      "minlength": "Vstupní hodnota musí mít alespoň {{ requiredLength }} znaků.",
      "maxlength": "Vstupní hodnota musí mít maximálně {{ requiredLength }} znaků.",
      "maxNumberSms": "Maximální počet {{ max }} Bylo překročeno množství SMS",
      "mustContainContent": "{{ nameOfInput }} musí obsahovat {{ mustContainContent }}",
      "required": "Tyto informace jsou vyžadovány",
      "sameValue": "Potvrzovací heslo není stejné jako zadané heslo."
    }
  }
}
